"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UInt64_1 = require("../UInt64");
const MosaicLevyType_1 = require("./MosaicLevyType");
const defaultMosaicLevyOnePercentValue = 100000; // default amount that represent 1% of native currency
class MosaicLevy {
    constructor(type, recipient, mosaicId, fee) {
        this.type = type;
        this.recipient = recipient;
        this.mosaicId = mosaicId;
        this.fee = fee;
    }
    static createWithPercentageFee(recipient, mosaicId, percentage, mosaicOnePercentValue) {
        return new MosaicLevy(MosaicLevyType_1.MosaicLevyType.LevyPercentileFee, recipient, mosaicId, MosaicLevy.createLevyFeePercentile(percentage, mosaicOnePercentValue));
    }
    static createWithAbsoluteFee(recipient, mosaicId, amount) {
        return new MosaicLevy(MosaicLevyType_1.MosaicLevyType.LevyAbsoluteFee, recipient, mosaicId, UInt64_1.UInt64.fromUint(amount));
    }
    static createLevyFeePercentile(percentage, mosaicOnePercentValue) {
        if (mosaicOnePercentValue) {
            return UInt64_1.UInt64.fromUint(percentage * mosaicOnePercentValue);
        }
        return UInt64_1.UInt64.fromUint(percentage * defaultMosaicLevyOnePercentValue);
    }
}
exports.MosaicLevy = MosaicLevy;
//# sourceMappingURL=MosaicLevy.js.map